export const SUMSYMBOL_LIST_ATTEMPT = "SUMSYMBOL_LIST_ATTEMPT";
export const SUMSYMBOL_LIST_SUCCESS = "SUMSYMBOL_LIST_SUCCESS";
export const SUMSYMBOL_LIST_FAILED = "SUMSYMBOL_LIST_FAILED";
///////////////////////
export const LATESROI_LIST_ATTEMPT = "LATESROI_LIST_ATTEMPT";
export const LATESROI_LIST_SUCCESS = "LATESROI_LIST_SUCCESS";
export const LATESROI_LIST_FAILED = "LATESROI_LIST_FAILED";
////////////////////////
export const LATESTRADE_LIST_ATTEMPT = "LATESTRADE_LIST_ATTEMPT";
export const LATESTRADE_LIST_SUCCESS = "LATESTRADE_LIST_SUCCESS";
export const LATESTRADE_LIST_FAILED = "LATESTRADE_LIST_FAILED";
///////////////////////
export const SUMSTRATEGY_LIST_ATTEMPT = "SUMSTRATEGY_LIST_ATTEMPT";
export const SUMSTRATEGY_LIST_SUCCESS = "SUMSTRATEGY_LIST_SUCCESS";
export const SUMSTRATEGY_LIST_FAILED = "SUMSTRATEGY_LIST_FAILED";
///////////////////////
export const SUMSECTOR_LIST_ATTEMPT = "SUMSECTOR_LIST_ATTEMPT";
export const SUMSECTOR_LIST_SUCCESS = "SUMSECTOR_LIST_SUCCESS";
export const SUMSECTOR_LIST_FAILED = "SUMSECTOR_LIST_FAILED";
